



























































import Component from 'vue-class-component';
import TabsInfoMixin from './TabsInfoMixin';
import { Mixins } from 'vue-mixin-decorator';
import { Global } from '@/store';
import Utils from '@/modules/Utils';

@Component({
  components: {
  }
})
class VirtualControllerInfoTabs extends Mixins<TabsInfoMixin>(TabsInfoMixin) {
  @Global.State('lang') lang;

  get getGeoLocation() {
    return Utils.deviceLocation(this.device);
  }
}

export default VirtualControllerInfoTabs;
